// extracted by mini-css-extract-plugin
export default {"price":"ida-z","onSale":"jda-z","msrpLabelPrice":"kda-z","msrpLabel":"lda-z","originalPrice":"mda-z"};